import { Box, Typography } from "@mui/material";
import { EmptyMessageWrapper, QuestionListStyle } from "../question.style";

const QBEmptyPreview = () => {
  return (
    <Box sx={QuestionListStyle}>
      <EmptyMessageWrapper>
        <Typography variant="h3" color="grey">
          No questions found
        </Typography>
      </EmptyMessageWrapper>
    </Box>
  );
};

export default QBEmptyPreview;
